var path = 'app/scripts/modules/dcos/serverGroup/configure/wizard/templateSelection.html';
var html = "<deploy-initializer cloud-provider=\"dcos\"\n                     command=\"command\"\n                     application=\"application\"\n                     parent-state=\"state\"\n                     template-selection-text=\"ctrl.templateSelectionText\"\n                     on-template-selected=\"ctrl.templateSelected()\"></deploy-initializer>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/dcos/serverGroup/configure/wizard/templateSelection.html
// module id = 1754
// module chunks = 0